<script setup lang="ts">
import SummaryCoverage from '~/components/sidebar/SummaryCoverage.vue'
import SummaryDetails from '~/components/sidebar/SummaryDetails.vue'
import SummaryHeader from '~/components/sidebar/SummaryHeader.vue'
import SummaryOptions from '~/components/sidebar/SummaryOptions.vue'
import SummaryVehicle from '~/components/sidebar/SummaryVehicle.vue'
import { useOfferAdditionalOptions } from '~/composables/offer-additional-options'
import { useExtrasStore } from '~/stores/extras'
import { useLocationStore } from '~/stores/location'
import { useOfferStore } from '~/stores/offer'
import { useReferralStore } from '~/stores/referral'

const referralStore = useReferralStore()
const metaFlowOffersEnabled = useRuntimeConfig().public.META_OFFERS_ENABLED && referralStore.isMetaFlow

const extrasStore = useExtrasStore()
const offerStore = useOfferStore()

const { option: crossBorderOption } = useOfferAdditionalOptions(`cross_border_${useLocationStore().city.country}`, '.')
const { option: comfortOption } = useOfferAdditionalOptions('cleaned', '\n', 'refueled')

const plusCoverageChosen = computed<boolean>(() => extrasStore.propertyChosen(crossBorderOption.value?.id))
const comfortChosen = computed<boolean>(() => extrasStore.propertyChosen(comfortOption.value?.id))
</script>

<template>
  <aside class="mt-[58px] mr-12 mb-24 ml-2 lg:ml-32 xl:ml-32 px-0 pt-0 border-0 h-fit rounded-2xl shadow-10">
    <SummaryHeader />

    <SummaryDetails />

    <SummaryVehicle />

    <SummaryCoverage />

    <Transition mode="in-out" name="jump">
      <SummaryOptions v-if="plusCoverageChosen || comfortChosen || metaFlowOffersEnabled" />
    </Transition>
  </aside>
</template>

<style scoped lang="scss">
.jump-enter-active {
  transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.7, 1);
}

.jump-leave-active {
  transition: transform 0.1s;
}

.jump-enter {
  opacity: 0.5;
  transform: translateY(20px) rotateX(35deg);
}

.jump-enter-to {
  opacity: 1;
  animation: enter-keyframes 0.3s;
}

.jump-leave-to {
  opacity: 0;
  transform: translateY(-100px);
}

.jump-leave {
  opacity: 1;
  transform: translateY(0);
}

@keyframes enter-keyframes {
  0% {
    transform: translateY(0) rotateX(-35deg);
  }

  70% {
    transform: translateY(20px) rotateX(-15deg);
  }

  100% {
    transform: translateY(0) rotateX(0deg);
  }
}
</style>
